import { Grid, Paper, Box, Typography } from '@mui/material';
export default function AssesmentInfo(props) {
  return (
    <>
      <Grid
        item
        sm={10}
        md={6}
        lg={6}
        xl={6}
        sx={{
          backgroundColor: '#118553',
          color: '#FFFFFF',
          margin: '3vh',
        }}
        component={Paper}
      >
        <Box textAlign="left" sx={{ py: 4, px: 4 }}>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Suma dopłat: </Typography>
            <Typography variant="h6" align="right">
              {Number(props.data.directPaymentsTotalValue).toFixed(2)} zł
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Powierzchnia upraw (ha): </Typography>
            <Typography variant="h6" align="right">
              {props.data.fieldsArea}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Imię i nazwisko: </Typography>
            <Typography variant="h6" align="right">
              {props.data.name} {props.data.surname}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">PESEL: </Typography>
            <Typography variant="h6" align="right">
              {props.data.pesel}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Numer identyfikacyjny: </Typography>
            <Typography variant="h6" align="right">
              {props.data.arimrNumber}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Numer dokumentu: </Typography>
            <Typography variant="h6" align="right">
              {props.data.confirmationNumber}
            </Typography>
          </Grid>
        </Box>
      </Grid>
    </>
  );
}
